<script setup>
import { computed } from 'vue';

const props = defineProps({
  reactions: { type: Array, default: () => [] },
  currentUserId: { type: Number, required: true },
  align: { type: String, default: 'start' },
});

const emit = defineEmits(['toggle']);

const grouped = computed(() => {
  const byEmoji = new Map();
  props.reactions.forEach(reaction => {
    const list = byEmoji.get(reaction.emoji) || [];
    list.push(reaction);
    byEmoji.set(reaction.emoji, list);
  });

  return Array.from(byEmoji.entries()).map(([emoji, list]) => ({
    emoji,
    count: list.length,
    reactedByMe: list.some(
      r => r.senderType === 'User' && r.senderId === props.currentUserId
    ),
  }));
});
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div
    v-if="grouped.length"
    class="flex flex-wrap gap-1 mt-0.5"
    :class="align === 'end' ? 'justify-end' : 'justify-start'"
  >
    <button
      v-for="group in grouped"
      :key="group.emoji"
      class="flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-xs border border-n-weak bg-n-solid-1 hover:bg-n-alpha-2 transition-colors"
      :class="{ 'border-n-brand bg-n-alpha-2': group.reactedByMe }"
      @click="emit('toggle', group.emoji)"
    >
      <span>{{ group.emoji }}</span>
      <span class="text-n-slate-11 tabular-nums">{{ group.count }}</span>
    </button>
  </div>
</template>
